import {Box} from "@mui/material";
import * as React from "react";

export default function DateIconResultRecordModal(props: any) {
    const { sx, ...otherProps } = props;
    return (
        <Box {...otherProps} sx={{ 
            display: "flex", 
            alignItems: "center", 
            gap: "4px", 
            width: "24px", 
            height: "24px",
            cursor: "pointer", 
            position: "relative",
            zIndex: 1,
            flexShrink: 0,
            ...sx
        }}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V9H16V8H2V18H9V20H2ZM2 6H16V4H2V6ZM11 20V16.925L16.525 11.425C16.675 11.275 16.8417 11.1667 17.025 11.1C17.2083 11.0333 17.3917 11 17.575 11C17.775 11 17.9667 11.0375 18.15 11.1125C18.3333 11.1875 18.5 11.3 18.65 11.45L19.575 12.375C19.7083 12.525 19.8125 12.6917 19.8875 12.875C19.9625 13.0583 20 13.2417 20 13.425C20 13.6083 19.9667 13.7958 19.9 13.9875C19.8333 14.1792 19.725 14.35 19.575 14.5L14.075 20H11ZM12.5 18.5H13.45L16.475 15.45L16.025 14.975L15.55 14.525L12.5 17.55V18.5ZM16.025 14.975L15.55 14.525L16.475 15.45L16.025 14.975Z" fill="#1D1A1A"/>
            </svg>
        </Box>
    );
}